import { render, staticRenderFns } from "./AnimalPoly.vue?vue&type=template&id=e2ffc1b8&scoped=true"
import script from "./AnimalPoly.vue?vue&type=script&lang=js"
export * from "./AnimalPoly.vue?vue&type=script&lang=js"
import style0 from "./AnimalPoly.vue?vue&type=style&index=0&id=e2ffc1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ffc1b8",
  null
  
)

export default component.exports